import SourceRenderer from '../html/SourceRenderer';
import VersionRenderer from '../html/VersionRenderer';
import VersionStyle from '../html/VersionStyle';
import Source from '../sources/Source';
import SourceTestament from '../sources/SourceTestament';
import VersionGroup from './VersionGroup';

interface Props {
    index: number;
    code: string;
    name: string;
    group: VersionGroup;
    testament: SourceTestament;
    renderer: VersionRenderer;
}

interface FromSourceProps {
    group: VersionGroup;
    style: VersionStyle;
    code?: string;
    name?: string;
}

export default class Version {

    public static create(props: Props): Version {
        return new Version(props);
    }

    public static fromSource(source: Source, props: FromSourceProps): Version {
        return new Version({
            code: props.code || source.getCode(),
            group: props.group,
            index: source.getIndex(),
            name: props.name || source.getName(),
            renderer: new SourceRenderer(source, props.style),
            testament: source.getTestament()
        });
    }

    private constructor(private readonly props: Props) {
    }

    public getIndex(): number {
        return this.props.index;
    }

    public getCode(): string {
        return this.props.code;
    }

    public getName(): string {
        return this.props.name;
    }

    public getGroup(): VersionGroup {
        return this.props.group;
    }

    public getTestament(): SourceTestament {
        return this.props.testament;
    }

    public getRenderer(): VersionRenderer {
        return this.props.renderer;
    }
}
